import { AlertColor, LinearProgress, Typography } from "@mui/material";
import WhiteCard from "../WhiteCard";
import { useMemo, useState } from "react";

import { useGetTasksByPatientIdQuery } from "src/api/services/tasksApi";
import DataTable from "../DataTable";
import { useColumns } from "./useColumns";
import TimedAlert from "src/shared/TimedAlert";

interface Props {
  patientId: number;
}

const TaskHistory = ({ patientId }: Props) => {
  const { data, isFetching } = useGetTasksByPatientIdQuery(patientId);
  const height = useMemo(() => window.innerHeight - 170 - 64 - 32, []);
  const [alert, setAlert] = useState<{
    text: string;
    severity: AlertColor;
  } | null>(null);
  const columns = useColumns(setAlert);

  const tasks = useMemo(() => {
    if (data == null) return [];

    return data;
  }, [data]);

  return (
    <WhiteCard
      width="320px"
      maxHeight="400px"
      gap={1}
      sx={{ overflowY: "auto", overflowX: "auto" }}
    >
      <Typography variant="subtitle2">TASK HISTORY</Typography>
      {isFetching ? <LinearProgress color="secondary" /> : null}
      <DataTable
        columns={columns}
        data={tasks}
        height={height}
        primaryKey="id"
      />
      {alert ? <TimedAlert alert={alert} setAlert={setAlert} /> : null}
    </WhiteCard>
  );
};

export default TaskHistory;
